module.exports = __webpack_public_path__ + "static/img/img-card-crm-motorcycle-v1.2555d40.png";